import { useParams } from 'react-router-dom'

import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useGenresAndLanguagesAnalytics } from 'src/Hooks/useGenresAndLanguagesAnalytics'
import { useUpdateSpotifyCampaignGenresMutation } from 'src/Redux/spotify-campaignApi'
import { useLazyGetBudgetRangeQuery } from 'src/Redux/spotifyBudgetRangeApi'
import { GenreWithCurators } from 'src/Redux/spotifyCampaignGenresApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

type SaveGenres = (selectedGenres: GenreWithCurators[]) => void

type UseSaveGenresResult = {
  saveGenres: SaveGenres
  isLoading: boolean
}

export const useSaveGenres = (): UseSaveGenresResult => {
  const { number: id } = useParams<{ number: string }>()
  const [updateSpotifyCampaignGenres, { isLoading }] =
    useUpdateSpotifyCampaignGenresMutation()
  const { setSearch } = useCustomSearchParams()
  const { handleGenreAddedEvent } = useGenresAndLanguagesAnalytics()
  const [getCampaignBudgetRange] = useLazyGetBudgetRangeQuery()
  const { hasSelectedLanguagesWithoutAny } = useSpotifyCampaignStatus()

  const saveGenres: SaveGenres = (selectedGenres) => {
    if (!id) {
      return
    }
    updateSpotifyCampaignGenres({
      id,
      genreIds: Array.from(new Set(selectedGenres.map((el) => Number(el.id)))),
    })
      .unwrap()
      .then(() => {
        if (hasSelectedLanguagesWithoutAny) {
          getCampaignBudgetRange(String(id))
        }

        handleGenreAddedEvent({
          platformName: CampaignPlatformTypeEnum.SPOTIFY,
          genreId: selectedGenres.map((el) => Number(el.id)).join(),
          genreName: selectedGenres.map((el) => String(el.genreName)).join(),
        })
        setSearch({ modal: null })
      })
  }

  return { saveGenres, isLoading }
}
